import * as React from 'react';
import {useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import Top from "../Top";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import {styled} from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import {Modal, Typography} from '@mui/material';
import {FormContainer, PasswordElement, PasswordRepeatElement, TextFieldElement} from "react-hook-form-mui";

import HttpsIcon from '@mui/icons-material/Https';
import HomeIcon from '@mui/icons-material/Home';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import WcIcon from '@mui/icons-material/Wc';
import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import api from "../../utils/api";
import * as util from "../../utils/util";
import DaumPostcode from "react-daum-postcode";
import tabbg from "../../assets/images/tab_05.png"

const typeSaveBasicParam = { id: '', companyId: '', userName: '', birthDate: '', cusId: '', phone: '', address: '', buildingNum: ''
  ,email: '', zipCode: '', beforePassword: '', afterPassword: '', afterPasswordCheck: '' };

const UserJoin = () => {
  const navigate = useNavigate();
  const [alignment, setAlignment] = React.useState('1');
  const [isEmailCheck, setIsEmailCheck] = React.useState(false);
  const [userId, setUserId] = React.useState('');
  const [isOpen, setIsOpen] = React.useState(false);
  const [saveBasicParam, setSaveBasicParam] = React.useState(typeSaveBasicParam);
  const location = useLocation();
  
  useEffect(() => {
    const locationSearch = new URLSearchParams(location.search);
    const buffer = locationSearch.get('data') || '';
    const urlSearchParams = new URLSearchParams( `?${atob(buffer)}`);
    let params = Object.fromEntries(urlSearchParams.entries());
    // 개발 환경에서 nice 인증 값이 리턴되지 않아 운영에서 테스트 예정
    setSaveBasicParam((prev) => true ? {...prev, userName: decodeURIComponent(params.name)} : prev);
    setSaveBasicParam((prev) => true ? {...prev, birthDate: decodeURIComponent(params.birthdate)} : prev);  // YYYYMMDD
    // setSaveBasicParam((prev) => true ? {...prev, userName: '홍길동'} : prev);
    // setSaveBasicParam((prev) => true ? {...prev, birthDate: '19770707'} : prev);  // YYYYMMDD
  }, []);
  
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };
  
  // 회원 추가정보를 받기 위한 화면으로 이동
  async function handleSaveUser(data :any){
    if(!isEmailCheck){
      alert('아이디 중복확인을 해주세요.');
    }else{
      data.sex = alignment;
      data.password = data.afterPassword;
      data.name = data.userName;
      data.sex = data.sex === '0' ? false : true;
      data.phone = data.phone.substring(0,3) + '-' + data.phone.substring(3,7) + '-' + data.phone.substring(7,11);
      data.zipCode = saveBasicParam.zipCode;
      data.birthDate = `${data.birthDate.substring(0, 4)}-${data.birthDate.substring(4, 6)}-${data.birthDate.substring(6, 8)}`;
      data.companyId = 'DUALHEALTH';  // 개인회원 가입 시, 입력 값
      
      navigate('/Join/UserJoinPhysical', {state: data});
    }
  }
  
  const handlePopClose = () => {
    setIsOpen(false)
  }
  
  const handleComplete = (data :any) => {
    setSaveBasicParam((prev) => true ? {...prev, address: data.address} : prev);
    setSaveBasicParam((prev) => true ? {...prev, zipCode: data.zonecode} : prev);
    handlePopClose();
  };

  const img = {
    backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2, width: '80%', height: 200, mt: 1, ml:'auto', mr: 'auto'
  }

  return (
    <Container sx={Logbg}>
      <Box sx={img}><Typography sx={{ color: '#fff', textAlign: 'center', fontSize: 25, lineHeight: '200px' }}>회원 가입</Typography></Box>

      <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
        <FormContainer
          values={{id: saveBasicParam.id, userName: saveBasicParam.userName, birthDate: saveBasicParam.birthDate, 
          email: saveBasicParam.email, address: saveBasicParam.address, buildingNum: saveBasicParam.buildingNum,
          afterPassword: saveBasicParam.afterPassword, phone: saveBasicParam.phone, 
          afterPasswordCheck: saveBasicParam.afterPasswordCheck}}
          onSuccess={data => handleSaveUser(data)}
        >

          <Card sx={{ p: '20px 20px 30px 20px', bgcolor:'#fff', width: '60%', ml: 'auto', mr:'auto' }}>
            <Divider sx={{pt:2, pb: 2}}><b>로그인 정보</b></Divider>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1, width: '100%' }}>
              <AccountCircleIcon sx={profileIcon} />
              <TextFieldElement
                name="id"
                id="id" label="아이디" variant="standard"
                fullWidth
                rules={{
                  required: '아이디 필수 입력입니다.',
                }}
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, id: e.target.value} : prev);
                  setUserId(e.target.value);
                }}
                sx={loginField}
                inputProps={{ readOnly: isEmailCheck }}
              />
              <Button onClick={() => {
                if(util.strNull(userId) !== ''){
                  api.get('permission/customers/check', { params : {email: userId} }).then(res => {
                    setIsEmailCheck(res.data.success);
                    if(!res.data.success){
                      alert('이미 사용중이거나 사용할 수 없는 아이디입니다.');
                    }else{
                      alert('사용 가능한 아이디입니다.');
                    }
                  }).catch(function (error) {
                    console.log(error);
                  });
                }else{
                  alert('아이디 입력 후 시도해주세요.');
                }
              }} sx={{ fontSize: 12, minWidth: 70, border: '1px solid #0d6703', borderRadius: 20, color: '#0d6703', bgcolor: '#0d670314', fontWeight: 700, p: .5 }}>
                중복확인
              </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1 }}>
              <HttpsIcon sx={profileIcon} />
              <PasswordElement fullWidth id="input-new" label="비밀번호" variant="standard" type={'password'} name="afterPassword"
                rules={{
                  required: '필수 입력입니다.',
                  pattern: {
                    value: /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,15}$/i,
                    message: saveBasicParam.afterPassword.length > 15 ? '비밀번호는 8자리 이상 15자리 이하로 입력해주세요.' : '영문자+숫자+특수문자 조합 8자리 이상 필수',
                  },
                }}
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, afterPassword: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
              <HttpsIcon sx={profileIcon} />
              <PasswordRepeatElement passwordFieldName={'afterPassword'} name="afterPasswordCheck" fullWidth id="input-confirm"
                label="비밀번호 확인" variant="standard" type={'password'}
                rules={{
                  required: '필수 입력입니다.',
                }}
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, afterPasswordCheck: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
      
            <Divider sx={{pt:7, pb: 2}}><b>회원 정보</b></Divider>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1, width: '100%' }}>
              <AssignmentIndIcon sx={profileIcon} />
              <TextFieldElement
                name="userName"
                id="input-userName" label="이름" variant="standard"
                fullWidth
                inputProps={{ readOnly: true }}
                sx={loginField}
              />
              {/*<Button sx={{ fontSize: 12, minWidth: 70, border: '1px solid #ed6c02', borderRadius: 20, color: '#ed6c02', bgcolor: '#ed6c0214', fontWeight: 700, p: .5 }}>
                본인인증
              </Button>*/}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1, width: '100%' }}>
              <CalendarMonthIcon sx={profileIcon} />
              <TextFieldElement
                name="birthDate"
                id="input-birth" label="생년월일" variant="standard"
                fullWidth
                inputProps={{ readOnly: true }}
                sx={loginField}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1, width: '100%' }}>
              <WcIcon sx={profileIcon} />
              <Stack direction={'row'} alignItems={'baseline'} sx={{borderBottom:'1px solid #bbb', width:'100%'}}>
                <Typography gutterBottom sx={{ color: '#888', fontSize: 14, }}>성별</Typography>
                <ToggleButtonGroup
                  
                  size="small"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  aria-label="sex"
                  sx={{width:'75%', ml:'auto','& button:hover':{bgcolor: '#0d670314 !important'}, '& .MuiToggleButton-root.Mui-selected':{bgcolor:'#0d670314', color: '#0d6703'}}}
                >
                  <ToggleButton value="1" fullWidth><FaceIcon /></ToggleButton>
                  <ToggleButton value="0" fullWidth><Face4Icon /></ToggleButton>
                </ToggleButtonGroup>
              </Stack>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1 }}>
              <PhoneAndroidIcon sx={profileIcon} />
              <TextFieldElement
                name="phone"
                id="input-tel" label="휴대전화" variant="standard"
                fullWidth
                inputProps={{ maxLength: 11 }}
                rules={{
                  required: '필수 입력입니다.',
                  pattern: {
                    value: /^[0-9]{3}[0-9]{4}[0-9]{4}$/i,
                    message: '연락처 형식을 확인해주세요.',
                  },
                }}
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, phone: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1 }}>
              <EmailIcon sx={profileIcon} />
              <TextFieldElement
                name="email"
                id="input-email" label="이메일" variant="standard"
                fullWidth
                rules={{
                  required: '필수 입력입니다.',
                  pattern: {
                    value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                    message: '이메일 형식을 확인해주세요.',
                  },
                }}
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, email: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1, width: '100%' }}>
              <HomeIcon sx={profileIcon} />
              <TextFieldElement
                name="address"
                id="address" label="주소" variant="standard"
                fullWidth
                rules={{
                  required: '필수 입력입니다.',
                }}
                sx={loginField}
                inputProps={{ readOnly: true }}
              />
              <Button sx={{ fontSize: 12, minWidth: 70, border: '1px solid #0d6703', borderRadius: 20, color: '#0d6703', bgcolor: '#0d670314', fontWeight: 700, p: .5 }} onClick={() => setIsOpen(true)}>
                검색
              </Button>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1 }}>
              <HomeIcon sx={profileIcon} />
              <TextFieldElement
                name="buildingNum"
                id="buildingNum" label="상세주소" variant="standard"
                fullWidth
                onChange={(e :any) => {
                  setSaveBasicParam((prev) => true ? {...prev, buildingNum: e.target.value} : prev)
                }}
                sx={loginField}
              />
            </Box>
          </Card>

          <Box sx={{ p: '10px 0px 30px 0px', width: '63%' , ml:'auto', mr:'auto', mt: 3, display:'flex', '& button' :{width:'50%'}}}>
              <CareButton variant="contained" sx={{ bgcolor: '#0d670399', color: '#fff' , '&:hover':{bgcolor:'#074300'}}} onClick={() => navigate('../Join/Join')} >
                취소
              </CareButton>
              <CareButton variant="contained" type={'submit'} sx={{ bgcolor: '#0d6703', ml: 1, color: '#fff' , '&:hover':{bgcolor:'#074300'}}}>
                다음
              </CareButton>
          </Box>
        </FormContainer>

      </Stack>
      
      <Modal open={isOpen} onClose={handlePopClose} style={{display:'flex',alignItems:'center',justifyContent:'center', zIndex:9999}}>
        <div>
          <DaumPostcode onComplete={handleComplete} />
        </div>
      </Modal>
      
    </Container>

  );
}

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '50%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const loginField = {
  '& input': {
    fontSize: 14
  },
  '& label': {
    color: '#888',
    fontSize: 14
  },
  '& label.Mui-focused': {
    color: '#0d6703',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#0d6703',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f6f6f6',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px',
}

export default UserJoin;